// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --cl-color-white: hsl(0, 0%, 100%);

  --cl-color-info: #0f62fe;
  --cl-color-warning: #ff832b;
  --cl-color-error: #da1e26;
  --cl-color-success: #52b415;
}

.cl-icon, .cl-icon * {
  box-sizing: border-box;
}

.cl-icon {
  --icon-color: white;
  --icon-bg-color: #333;
  background: var(--icon-bg-color);
  color: var(--icon-color);
  border-radius: 100%;
  height: 20px;
  width: 20px;
  border: solid 4px var(--icon-bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cl-icon-error {
  --icon-bg-color: var(--cl-color-error);
}

.cl-icon-warn {
  --icon-bg-color: var(--cl-color-warning);
}

.cl-icon-info {
  --icon-bg-color: var(--cl-color-info);
}`, "",{"version":3,"sources":["webpack://./node_modules/@camunda/linting/assets/linting.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;;EAElC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[":root {\n  --cl-color-white: hsl(0, 0%, 100%);\n\n  --cl-color-info: #0f62fe;\n  --cl-color-warning: #ff832b;\n  --cl-color-error: #da1e26;\n  --cl-color-success: #52b415;\n}\n\n.cl-icon, .cl-icon * {\n  box-sizing: border-box;\n}\n\n.cl-icon {\n  --icon-color: white;\n  --icon-bg-color: #333;\n  background: var(--icon-bg-color);\n  color: var(--icon-color);\n  border-radius: 100%;\n  height: 20px;\n  width: 20px;\n  border: solid 4px var(--icon-bg-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cl-icon-error {\n  --icon-bg-color: var(--cl-color-error);\n}\n\n.cl-icon-warn {\n  --icon-bg-color: var(--cl-color-warning);\n}\n\n.cl-icon-info {\n  --icon-bg-color: var(--cl-color-info);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
